<template>
  <div class="animated fadeIn">
    <div>
      <b-card header="공개된 사전예약 리스트">
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByGoogleplayAndPreeceeding"
                 :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sortCompare="customSortCompare.bind(this, 'googlePlay')" :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            GooglePlay
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'googlePlay')" v-on:change="changeHandling(data.item, marketType.googlePlay, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <!--<b-link :to="{name: 'showListForm', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}, query:{market: 'googlePlay'}}" class="mr-2">[수정]</b-link>-->
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'googlePlay')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'googlePlay')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByAppstoreAndPreeceeding" :fields="fields"
                 :sortCompare="customSortCompare.bind(this, 'appStore')" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            AppStore
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'appStore')" v-on:change="changeHandling(data.item, marketType.appStore, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <!--<b-link :to="{name: 'showListForm', params: {pregId: data.item.id, appMasterId: data.item.appMasterId}, query:{market: 'appStore'}}" class="mr-2">[수정]</b-link>-->
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'appStore')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'appStore')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
        *광고사전예약/게임소식의 노출일정은 광고주센터에서 수정하실 수 있습니다. <b-link :href="gapAdminUrl" class="mr-2" style="margin-left: 5px;margin-top: 10px" target="_blank">광고주센터 바로가기></b-link>
      </b-card>
      <b-card header="공개 예정 사전예약 리스트">
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByGoogleplayAndExpected"
                 :sortCompare="customSortCompare.bind(this, 'googlePlay')" :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            GooglePlay
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'googlePlay')" v-on:change="changeHandling(data.item, marketType.googlePlay, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'googlePlay')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'googlePlay')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByAppstoreAndExpected"
                 :sortCompare="customSortCompare.bind(this, 'appStore')" :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            AppStore
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'appStore')" v-on:change="changeHandling(data.item, marketType.appStore, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'appStore')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'appStore')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
      </b-card>
      <b-card header="공개 종료된 사전예약 리스트">
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByGoogleplayAndFinish"
                 :sortCompare="customSortCompare.bind(this, 'googlePlay')" :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            GooglePlay
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'googlePlay').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'googlePlay')" v-on:change="changeHandling(data.item, marketType.googlePlay, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'googlePlay')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'googlePlay')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
        <b-table hover striped bordered small fixed responsive="sm" :items="this.showListByAppstoreAndFinish"
                 :sortCompare="customSortCompare.bind(this, 'appStore')" :fields="fields" :show-empty=true empty-text="등록된 예약이 없어요." caption-top :sort-by.sync="sortBy" :sort-desc=true>
          <template slot="table-caption">
            AppStore
          </template>
          <template slot="pregTypeStr" slot-scope="data">
            {{ getPregTypeStr(data.item) }}
          </template>
          <template slot="startShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'startShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="endShowTime" slot-scope="data">
            {{getMomentByMarket(data.item.marketInfoList, 'endShowTime', 'appStore').format('YY.MM.DD HH:mm')}}
          </template>
          <template slot="displayLevel" slot-scope="data">
            <select :ref="'type' + data.item.id" style="width: 50px" :value="getDisplayLevel(data.item, 'appStore')" v-on:change="changeHandling(data.item, marketType.appStore, $event)">
              <option :value=DISPLAY_LEVEL.ON>ON</option>
              <option :value=DISPLAY_LEVEL.OFF>OFF</option>
              <option :value=DISPLAY_LEVEL.DEVONLY>DEVONLY</option>
            </select>
          </template>
          <template slot="management" slot-scope="data">
            <span v-if="data.item.gapCampaignId != null">
              <b-link :href="gapAdminUrl" class="mr-2" target="_blank" >광고주센터></b-link>
            </span>
            <span v-else>
              <b-link @click="moveEditPage(data.item, 'appStore')" class="mr-2">[수정]</b-link>
              <b-link v-on:click="submitHandling(data.item, 'appStore')">[삭제]</b-link>
            </span>
          </template>
        </b-table>
      </b-card>
    </div>
  </div>
</template>
<script>
import { labelClasses, PREECEEDING, EXPECTED, FINISH, DISPLAY_LEVEL } from '@/constants'
import { MODULE_NAME as PREG_MODULE, FETCH_PREGS, FETCH_CODES } from '@/store/preg/actions.type'
import { mapGetters, mapMutations } from 'vuex'
import { getAxiosErrorMessage, $showModalWithErrorMsg } from '@/common/util'
import { SHOW_MODAL } from '@/store/ui/mutations.type'
import gapPregService from '@/common/api/gap.preg.service'
import pregService from '@/common/api/preg.service'
import moment from 'moment'
export default {
  data () {
    return {
      displayLevel: 1,
      gapAdminUrl: process.env.VUE_APP_GAP_ADMIN_URL,
      DISPLAY_LEVEL: DISPLAY_LEVEL,
      labelClasses: labelClasses,
      sortBy: '',
      fields: [
        {key: 'id', label: 'id', class: 'align-middle text-center', thStyle: {width: '60px'}},
        {key: 'pregTypeStr', label: '구분', class: 'align-middle text-center'},
        {key: 'name', label: '제목', class: 'align-middle text-center'},
        {key: 'startShowTime', label: '시작일', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'endShowTime', label: '종료일', class: 'align-middle text-center', sortable: true, thStyle: {width: '150px'}},
        {key: 'displayLevel', label: 'On/Off', class: 'align-middle text-center', thStyle: {width: '60px'}},
        {key: 'management', label: '사전예약 관리', class: 'align-middle text-center', thStyle: {width: '150px'}}
      ],
      currentPage: 1,
      perPage: 5,
      marketType: { googlePlay: 'googlePlay', appStore: 'appStore' },
      gapPregList: {
        preeceeding: {googlePlay: [], appStore: []},
        expected: {googlePlay: [], appStore: []},
        finish: {googlePlay: [], appStore: []},
      }
    }
  },
  mounted () {
    this.$store.dispatch(PREG_MODULE + FETCH_CODES)
      .catch($showModalWithErrorMsg.bind(this))
    this.$store.dispatch(PREG_MODULE + FETCH_PREGS)
      .catch($showModalWithErrorMsg.bind(this))

    gapPregService.getFinishedPregList()
            .then(({data}) => {
              console.log('response')
              console.log(data)

              if (data.status === 200) {
                // this.gapPregList = this.getPregListWithoutFrontInfo(data.data)
                this.gapPregList = this.classifyGapPregs(data.data);
                console.log(this.gapPregList)
                console.log('this.gapPregList')
              } else {
                alert('광고 사전예약 조회에 실패했습니다.')
              }
            });

    console.log('this.showListByAppstoreAndFinish')
    console.log(this.showListByAppstoreAndFinish)
  },
  computed: {
    // 공개 중
    showListByGoogleplayAndPreeceeding () {
      // return this.getFilteredListByMarketAndStatus('googlePlay', PREECEEDING)
      let result = this.getFilteredListByMarketAndStatus('googlePlay', PREECEEDING);
      return this.pushGapPregList(result, PREECEEDING, 'googlePlay');
    },
    showGapPregListByGoogleplayAndPreeceeding () {
      let result = []
      this.getFilteredListByMarketAndStatus('googlePlay', PREECEEDING).forEach(el => {
        result.push({
          id: el.id,
          name: el.name,
          marketInfoList: el.marketInfoList,
          appMasterId: el.appMasterId
        })
      });
      return this.pushGapPregList(result, PREECEEDING, 'googlePlay');
    },
    showListByAppstoreAndPreeceeding () {
      let result = this.getFilteredListByMarketAndStatus('appStore', PREECEEDING);
      return this.pushGapPregList(result, PREECEEDING, 'appStore');
    },
    // 공개 예정
    showListByGoogleplayAndExpected () {
      // return this.getFilteredListByMarketAndStatus('googlePlay', EXPECTED)
      let result = this.getFilteredListByMarketAndStatus('googlePlay', EXPECTED)
      return this.pushGapPregList(result, EXPECTED, 'googlePlay');
    },
    showListByAppstoreAndExpected () {
      // return this.getFilteredListByMarketAndStatus('appStore', EXPECTED)
      let result = this.getFilteredListByMarketAndStatus('appStore', EXPECTED)
      return this.pushGapPregList(result, EXPECTED, 'appStore');
    },
    // 공개 종료
    showListByGoogleplayAndFinish () {
      // return this.getFilteredListByMarketAndStatus('googlePlay', FINISH)
      let result = this.getFilteredListByMarketAndStatus('googlePlay', FINISH)
      return this.pushGapPregList(result, FINISH, 'googlePlay');
    },
    showListByAppstoreAndFinish () {
      // return this.getFilteredListByMarketAndStatus('appStore', FINISH)
      let result = this.getFilteredListByMarketAndStatus('appStore', FINISH)
      return this.pushGapPregList(result, FINISH, 'appStore');
    },
    ...mapGetters(PREG_MODULE, [
      'pregListWithMomentAndStatus'
    ])
  },
  methods: {
    getDisplayLevel(item, marketType) {
      if (item.gapCampaignId == null) {
        for (let i = 0; i < item.marketInfoList.length; i++) {
          if (item.marketInfoList[i].marketType === marketType)
            return item.marketInfoList[i].displayLevel
        }
      }
      else
        return item.displayLevel;
    },
    setDisplayLevel(item, marketType, level) {
      if (item.gapCampaignId == null) {
        for (let i = 0; i < item.marketInfoList.length; i++) {
          if (item.marketInfoList[i].marketType === marketType)
            item.marketInfoList[i].displayLevel = level
        }
      }
      else
        item.displayLevel = level;
    },
    getPregTypeStr(item) {
      if (item.gapCampaignId == null) return '사전예약'
      else if (item.pregType === 'gameNews') return '게임소식'
      else return '광고사전예약'
    },
    changeHandling(item, marketType, event) {
      // 바꾸려고 선택한 값 : event.target.value
      // 기존 값 값 : item.displayLevel
      const BERFORE = this.getDisplayLevel(item);
      const SELECTED = parseInt(event.target.value)

      let confirmText

      if(SELECTED === DISPLAY_LEVEL.ON) {
        confirmText = '노출(ON) 하시겠습니까?'
      } else if (SELECTED === DISPLAY_LEVEL.OFF) {
        confirmText = '비 노출(Off) 하시겠습니까?'
      } else {
        confirmText = '개발 환경 노출 (DEVONLY) 하시겠습니까?'
      }

      let isToggle = window.confirm(confirmText)
      let fail = () => {
        console.log('fail : type' + item.id + ' :: ' +BERFORE)
        this.$refs['type' + item.id].value = BERFORE
        this.setDisplayLevel(item, marketType, BERFORE)
        $showModalWithErrorMsg.bind(this)
      }
      if (isToggle) {
        this.setDisplayLevel(item, marketType, SELECTED)
        if (item.gapCampaignId == null) {
          pregService.updateDisplayLevel(item.id, marketType, SELECTED).catch(fail)
        } else {
          gapPregService.updateDisplayLevel(item.id, item.gapCampaignId, marketType, SELECTED)
              .then(({data}) => {
                console.log(data)
                if (data.status !== 200)
                  fail()
              })
              .catch(fail)
        }
      } else {
        this.$refs['type' + item.id].value = BERFORE
        this.setDisplayLevel(item, marketType, BERFORE)
      }
    },
    pushGapPregList(target, status, market) {
      this.gapPregList[status][market].sort((a, b) => {
        if (b.pregMaster.type !== a.pregMaster.type) {
          if (b.pregMaster.type === 'gameNews') return -1
          if (a.pregMaster.type === 'gameNews') return 1
        }

        const aMoment = this.getMomentByMarket(a.marketInfoDtoList, 'startShowTime', market)
        const bMoment = this.getMomentByMarket(b.marketInfoDtoList, 'startShowTime', market)
        return aMoment.isBefore(bMoment) ? 1 : -1
      });
      this.gapPregList[status][market].forEach(el => {
        el.marketInfoDtoList.forEach(marketInfo => {
          if(marketInfo.marketType === market && marketInfo.startShowTime != null && marketInfo.endShowTime != null) {
            target.push({
              id: el.pregMaster.id,
              gapCampaignId: el.pregMaster.gapCampaignId,
              name: el.pregMaster.name,
              pregType: el.pregMaster.type,
              marketInfoList: el.marketInfoDtoList,
              appMasterId: el.pregMaster.appInfo.appMasterId ? el.pregMaster.appInfo.appMasterId : 0,
              displayLevel: marketInfo.displayLevel
            })
          }
        })
      });
      return target
    },
    classifyGapPregs(gapPregList) {
      let gapPregs = {
        preeceeding: {googlePlay: [], appStore: []},
        expected: {googlePlay: [], appStore: []},
        finish: {googlePlay: [], appStore: []},
      };
      let toDay = new Date().getTime();
      gapPregList.forEach(preg => {
        preg.marketInfoDtoList.forEach(marketInfo => {
          if (marketInfo.startShowTime != null && marketInfo.endShowTime != null) {
            let c = this.compareTime(marketInfo.startShowTime, marketInfo.endShowTime, toDay);
            // gapPregs[c] = gapPregs[c]?gapPregs[c]:{};
            // gapPregs[c][marketInfo.marketType] = gapPregs[c][marketInfo.marketType]?gapPregs[c][marketInfo.marketType]:[];
            marketInfo.startShowTime = moment(marketInfo.startShowTime);
            marketInfo.endShowTime = moment(marketInfo.endShowTime);
            gapPregs[c][marketInfo.marketType].push(preg)
          }
        })
      });

      return gapPregs;
    },
    compareTime(startTime, endTime, cur) {
      return cur<startTime?EXPECTED:cur<=endTime?PREECEEDING:FINISH
    },
    customSortCompare (market, a, b, key) {
      if (key === 'startShowTime' || key === 'endShowTime') {
        const aMoment = this.getMomentByMarket(a.marketInfoList, key, market)
        const bMoment = this.getMomentByMarket(b.marketInfoList, key, market)
        return aMoment.isBefore(bMoment) ? -1 : 1
      }
      return null
    },
    getMomentByMarket (infoList, momentProperty, market) {
      for (let i = 0; i < infoList.length; i++) {
        if (infoList[i].marketType === market) {
          return infoList[i][momentProperty]
        }
      }
      return null
    },
    getFilteredListByMarketAndStatus (market, status) {
      let result = this.pregListWithMomentAndStatus.filter(item => {
        for (let i = 0; i < item.marketInfoList.length; i++) {
          if (item.marketInfoList[i].marketType === market && item.marketInfoList[i].showStatus.value === status) {
            return true
          }
        }
        return false
      })
      result.sort((a, b) => {
        const aMoment = this.getMomentByMarket(a.marketInfoList, 'startShowTime', market)
        const bMoment = this.getMomentByMarket(b.marketInfoList, 'startShowTime', market)
        return aMoment.isBefore(bMoment) ? 1 : -1
      });

      return result;
    },
    deleteGapPregShowTime(item, market) {
      let showListDto = {
        pregMasterMarketInfoList: []
      }
      showListDto.gapCampaignId = item.gapCampaignId;
      showListDto.pregMasterId = item.id;
      // showListDto.pregMasterMarketInfoList = JSON.parse(JSON.stringify(item.marketInfoList))
      showListDto.pregMasterMarketInfoList = item.marketInfoList
      for (let i = 0; i < showListDto.pregMasterMarketInfoList.length; i++) {
        if (showListDto.pregMasterMarketInfoList[i].marketType === market) {
          showListDto.pregMasterMarketInfoList[i].startShowTime = null
          showListDto.pregMasterMarketInfoList[i].endShowTime = null
        }
        // showListDto.pregMasterMarketInfoList[i].benefitInfo = JSON.stringify(showListDto.pregMasterMarketInfoList[i].benefitInfo)
      }
      gapPregService.updateShowTime(item.gapCampaignId, showListDto)
              .then((res) => {
                this[SHOW_MODAL]({msg: '삭제하였습니다', okHandling: () => {}})
              })
              .catch((error) => {
                console.log(error)
                const errorMsg = getAxiosErrorMessage(error)
                this[SHOW_MODAL]({msg: errorMsg, okHandling: () => {}})
              })
    },
    deletePregShowTime(marketInfoList, market) {
      let showListDto = {
        pregMasterMarketInfoList: []
      }
      showListDto.pregMasterMarketInfoList = marketInfoList
      for (let i = 0; i < showListDto.pregMasterMarketInfoList.length; i++) {
        if (showListDto.pregMasterMarketInfoList[i].marketType === market) {
          showListDto.pregMasterMarketInfoList[i].startShowTime = null
          showListDto.pregMasterMarketInfoList[i].endShowTime = null
        }
        showListDto.pregMasterMarketInfoList[i].benefitInfo = JSON.stringify(showListDto.pregMasterMarketInfoList[i].benefitInfo)
      }
      pregService.updateShowTime(showListDto)
              .then((res) => {
                this[SHOW_MODAL]({msg: '삭제하였습니다.', okHandling: () => {}})
              })
              .catch((error) => {
                console.log(error)
                const errorMsg = getAxiosErrorMessage(error)
                this[SHOW_MODAL]({msg: errorMsg, okHandling: () => {}})
              })
    },
    submitHandling (item, market) {
      if (item.id < 1000) {
        this.deletePregShowTime(item.marketInfoList, market)
      } else if (item.id >= 1000) {
        this.deleteGapPregShowTime(item, market)
      }
    },
    moveEditPage(item, market) {
      console.log('moveEditPage');
      console.log(item);
      if (item.id < 1000) {
        this.$router.push({name: 'showListForm', params: {pregId: item.id, appMasterId: item.appMasterId}, query: {market: market}})
      } else {
        this.$router.push({name: 'gapShowListInput', params: {pregId: item.id, campaignId: item.gapCampaignId}, query: {market: market}})
      }
    },
    ...mapMutations('ui', [SHOW_MODAL])
  }
}
</script>
